// Dawn replaces #cart-icon-bubble from the same response as the basket.
// Refresh on history restoration or cart events without rendered sections too.
(() => {
  let revision = 0;

  async function refreshSummary() {
    const requestRevision = ++revision;
    try {
      const url = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
      url.searchParams.set('sections', 'cart-icon-bubble');
      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) return;
      const sections = await response.json();
      if (requestRevision !== revision) return;
      renderSummary(sections['cart-icon-bubble']);
    } catch (error) {
      console.warn('Could not refresh basket summary', error);
    }
  }

  function renderSummary(html) {
    if (!html) return;
    const source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    const target = document.getElementById('cart-icon-bubble');
    if (source && target) target.innerHTML = source.innerHTML;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData?.errors) return;
      ++revision; // Older background requests must not overwrite this mutation.
      const html = event.cartData?.sections?.['cart-icon-bubble'];
      if (html) renderSummary(html);
      else refreshSummary();
    });
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshSummary();
  });
})();
